import * as React from "react";
import i18n from "i18n";
import { ViewsQualifyingViews } from "@graylog/server-api";
import { ControlLabel, FormGroup, HelpBlock, BootstrapModalForm, Input } from "components/bootstrap";
import Select from "components/common/Select";
import Spinner from "components/common/Spinner";
import UserNotification from "util/UserNotification";
import styles from "./SelectViewWithParameter.css";
const t = (key, options = {}) => i18n.t(key, { ns: "enterprise_common", ...options });
const _renderOption = ({ label, help }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("strong", null, label), help && ` - ${help}`);
class SelectViewWithParameter extends React.Component {
  constructor(props) {
    super(props);
    this._onSubmit = () => this.props.onSubmit(this.state.selectedView && this.state.selectedView.id, this.state.selectedParameter);
    this._onChange = (selectedView) => {
      const { viewSummaries } = this.state;
      if (selectedView && viewSummaries) {
        const view = viewSummaries.find((v) => v.id === selectedView);
        if (view) {
          const parameter = view.parameters[0];
          this.setState({
            selectedView: view,
            selectedParameter: parameter.name
          });
          return;
        }
      }
      this.setState({
        selectedParameter: void 0,
        selectedView: void 0
      });
    };
    this._onParameterChange = (event) => this.setState({ selectedParameter: event.target.value });
    this.state = {
      viewSummaries: void 0,
      selectedParameter: void 0,
      selectedView: void 0
    };
  }
  componentDidMount() {
    ViewsQualifyingViews.forParameter().then(
      (viewSummaries) => this.setState({ viewSummaries }),
      (error) => UserNotification.error(
        t("parameters.select_view.find_failed", { error }),
        t("parameters.select_view.find_failed_title")
      )
    );
  }
  render() {
    const { viewSummaries, selectedView, selectedParameter } = this.state;
    let content = /* @__PURE__ */ React.createElement(Spinner, null);
    if (viewSummaries) {
      const viewOptions = viewSummaries.sort((v1, v2) => v1.title.localeCompare(v2.title)).map((viewSummary) => ({
        label: viewSummary.title,
        value: viewSummary.id,
        help: viewSummary.summary
      }));
      let parameterSelection = null;
      if (selectedView) {
        const { parameters } = selectedView;
        parameterSelection = /* @__PURE__ */ React.createElement(FormGroup, { className: styles.indentingParameters }, /* @__PURE__ */ React.createElement(ControlLabel, null, t("parameters.select_view.select_parameter")), parameters.map((parameter) => /* @__PURE__ */ React.createElement(
          Input,
          {
            type: "radio",
            key: `radio-parameter-${parameter.name}`,
            id: parameter.name,
            name: "parameter",
            value: parameter.name,
            label: parameter.title,
            onChange: this._onParameterChange,
            help: parameter.description,
            checked: selectedParameter === parameter.name
          }
        )));
      }
      const selectedViewId = selectedView ? selectedView.id : void 0;
      content = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(
        Select,
        {
          placeholder: t("parameters.select_view.placeholder"),
          options: viewOptions,
          optionRenderer: _renderOption,
          onChange: this._onChange,
          clearable: true,
          value: selectedViewId
        }
      ), /* @__PURE__ */ React.createElement(HelpBlock, null, t("parameters.select_view.help"))), parameterSelection);
    }
    return /* @__PURE__ */ React.createElement(
      BootstrapModalForm,
      {
        title: t("parameters.select_view.modal_title"),
        submitButtonDisabled: !selectedParameter,
        show: true,
        onCancel: this.props.onClose,
        onSubmitForm: this._onSubmit
      },
      content
    );
  }
}
export default SelectViewWithParameter;
